// Copyright 2022, Imprivata, Inc.  All rights reserved.
import {
 useEffect } from 'react';
import { Button } from '@imprivata-cloud/components';
import { Flex, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import { useCreateInquiryMutation } from '../../api/hooks';
import LoadingSpinner from '../../components/loading/Loading';
import { useTranslation } from 'react-i18next';
const handlePrivacyPolicyClick = () => {
  window.open('https://www.imprivata.com/legal/end-user-privacy-notice', '_blank', 'noopener,noreferrer');
};
const AccountPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { fromVerifyFailure } = location.state || {};
  const { createInquiry, isPending, isSuccess, reset } = useCreateInquiryMutation();
  useEffect(() => {
    // Reset mutation state on component mount, used when navigating back to this page
    const handler = () => reset();
    window.addEventListener('pageshow', handler);
    return () => window.removeEventListener('pageshow', handler);
  }, []);
  if (isPending || isSuccess) {
    return (
      <Flex align="center" justify="center" vertical={true} className="h-100">
        <Typography.Title
          level={3}
          className="text-center mb-24 title-light"
          data-testid="loading-title"
        >
          {t('accountPage.need-id-selfie-verify-identity')}
        </Typography.Title>
        <LoadingSpinner />
      </Flex>
    );
  }
  return (
    <Flex align="center" justify="center" vertical={true} className="h-100">
      <Typography.Title level={3} className="text-center mb-24 title-light" data-testid="instructions-title">
        {fromVerifyFailure ? t('accountPage.verify-failed') : t('accountPage.verify-successful')}
      </Typography.Title>
  <Typography.Text className="text-center mb-24" data-testid="instructions-text">{t('accountPage.create-account-capture-id-selfie-verify')}</Typography.Text>
      <Flex vertical className="w-100" gap={16}>
        <Button
          type="default"
          label={t('accountPage.imprivata-privacy-policy')}
          onClick={handlePrivacyPolicyClick}
          className="w-100"
          data-testid="privacy-policy-button"
        />
        <Button
          type="primary"
          label={t('accountPage.continue')}
          onClick={() => createInquiry()}
          className="w-100"
          autoFocus
          data-testid="continue-button"
        />
      </Flex>
    </Flex>
  );
};
export default AccountPage;
